interface MutationOptions<T> {
  setLoading: (busy: boolean) => void
  setError: (message: string | null) => void
  errorMessage: string
  fallback: T
}

export async function runMutation<T>(
  options: MutationOptions<T>,
  fn: () => Promise<T>
): Promise<T> {
  options.setLoading(true)
  options.setError(null)
  try {
    return await fn()
  } catch (error) {
    options.setError(error instanceof Error ? error.message : options.errorMessage)
    return options.fallback
  } finally {
    options.setLoading(false)
  }
}
